import { RootState } from '@iwProvider/configureStore';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './LatestBankStatements.module.css';
import { TrueLayer } from '../../../../modals/linkOpenBankingModal/trueLayer';
import { BANK_STATMENT_DOC_TYPE } from '../../../../modals/uploadDocumentsModal/UploadDocumentsModalHelper';
import {
    isFlexiLoanBankStatementRequired,
    getBankStatementsDataRequirement
} from '../../../../multiLoanDashboard/dashboardWidgets/tabularFlexiDashboard/multiLoanDashboardSelector';
import { UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT } from '../../../ApplyFlexiLoanView.actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    uploadBankStatementDocument: (numberOfBankStatementsInMonths?: number) => {
        dispatch({
            type: UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT,
            documentType: BANK_STATMENT_DOC_TYPE,
            documentData: { numberOfBankStatementsInMonths }
        });
    }
});

const mapStateToProps = (state: RootState) => {
    return {
        isBankStatementsRequired: isFlexiLoanBankStatementRequired(state),
        bankStatementsDataRequirement: getBankStatementsDataRequirement(state)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const LatestBankStatements = ({
    statusIndicator,
    uploadBankStatementDocument,
    hasSubmitFailed,
    isBankStatementsRequired,
    bankStatementsDataRequirement
}: {
    statusIndicator?: React.ReactNode;
    hasSubmitFailed: boolean;
    bankStatementsDataRequirement: any;
} & PropsFromRedux) => {
    const numberOfBankStatmentsInMonths = bankStatementsDataRequirement
        ? bankStatementsDataRequirement.quantifier
        : 3;

    return (
        <div className={styles.connectOpenBanking}>
            <TrueLayer
                heading={
                    <div className="flex flex-row gap-l">
                        {statusIndicator}
                        <FormattedMessage
                            id="_.true_layer.bank_statements_for_months"
                            defaultMessage="Business bank statements for the last {months} months (from today)"
                            values={{
                                months: numberOfBankStatmentsInMonths
                            }}
                        />
                    </div>
                }
                handleUploadBankStatements={() =>
                    uploadBankStatementDocument(numberOfBankStatmentsInMonths)
                }
            />

            {isBankStatementsRequired && hasSubmitFailed && (
                <p data-testid="formErrors" className={styles.error}>
                    <FormattedMessage
                        id="_.connect_open_banking.submit_failed"
                        defaultMessage="Please link your business account or upload statements"
                    />
                </p>
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LatestBankStatements);
